import { useState } from "react";
import { getAPIFromDomain } from "../../../lib/api";

const usePermissionsIndex = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const api = getAPIFromDomain("accounts");

  const fetchPermissionsIndex = () => {
    const url = "/permissions";

    setLoading(true);
    setError(null);

    api
      .get(url)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(e);
      });
  };

  const permissionsIndex = { data, loading, error };
  return { permissionsIndex, fetchPermissionsIndex };
};

export { usePermissionsIndex };
